import React, { useState } from 'react';
import {
  Box,
  Container,
  Paper,
  TextField,
  Button,
  Typography,
  Alert,
  CircularProgress,
} from '@mui/material';
import { useAuth } from '../context/AuthContext';
import { memberAPI } from '../services/api';
import koalogo from '../assets/koalogo.png';
import MemberPortalFooter from './MemberPortalFooter';

const Login = () => {
  const { login } = useAuth();
  const [step, setStep] = useState('koalm'); // 'koalm' or 'otp'
  const [koalmNumber, setKoalmNumber] = useState('');
  const [otp, setOtp] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');

  const handleRequestOTP = async (e) => {
    e.preventDefault();
    setError('');
    setMessage('');
    setLoading(true);

    try {
      const response = await memberAPI.requestOTP(koalmNumber);
      if (response.success) {
        setMessage('OTP sent to your email address');
        setStep('otp');
      }
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to send OTP');
    } finally {
      setLoading(false);
    }
  };

  const handleVerifyOTP = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const response = await memberAPI.verifyOTP(koalmNumber, otp);
      if (response.success) {
        login(response.member);
      }
    } catch (err) {
      setError(err.response?.data?.error || 'Invalid OTP');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      }}
    >
      <Box
        sx={{
          flex: 1,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: 2,
        }}
      >
        <Container maxWidth="sm">
          <Paper
            elevation={10}
            sx={{
              padding: 4,
              borderRadius: 2,
              background: 'white',
            }}
          >
          <Box sx={{ textAlign: 'center', mb: 3 }}>
            <Box
              component="img"
              src={koalogo}
              alt="Kerala Orthopaedic Association"
              sx={{
                width: '150px',
                height: 'auto',
                marginBottom: 2,
              }}
            />
            <Typography variant="h4" component="h1" gutterBottom fontWeight="bold">
              KERALA ORTHOPAEDIC
            </Typography>
            <Typography variant="h5" component="h2" gutterBottom>
              ASSOCIATION
            </Typography>
            <Typography variant="h6" color="text.secondary" sx={{ mt: 2 }}>
              Member Portal
            </Typography>
          </Box>

          {error && (
            <Alert severity="error" sx={{ mb: 2 }}>
              {error}
            </Alert>
          )}

          {message && (
            <Alert severity="success" sx={{ mb: 2 }}>
              {message}
            </Alert>
          )}

          {step === 'koalm' ? (
            <form onSubmit={handleRequestOTP}>
              <TextField
                fullWidth
                label="KOALM Number"
                value={koalmNumber}
                onChange={(e) => setKoalmNumber(e.target.value)}
                margin="normal"
                required
                autoFocus
                disabled={loading}
              />
              <Button
                type="submit"
                fullWidth
                variant="contained"
                sx={{ mt: 3, mb: 2, py: 1.5 }}
                disabled={loading}
              >
                {loading ? <CircularProgress size={24} /> : 'Request OTP'}
              </Button>
            </form>
          ) : (
            <form onSubmit={handleVerifyOTP}>
              <TextField
                fullWidth
                label="Enter 6-digit OTP"
                value={otp}
                onChange={(e) => setOtp(e.target.value.replace(/\D/g, '').slice(0, 6))}
                margin="normal"
                required
                autoFocus
                disabled={loading}
                inputProps={{ maxLength: 6 }}
              />
              <Button
                type="submit"
                fullWidth
                variant="contained"
                sx={{ mt: 3, mb: 2, py: 1.5 }}
                disabled={loading || otp.length !== 6}
              >
                {loading ? <CircularProgress size={24} /> : 'Verify & Login'}
              </Button>
              <Button
                fullWidth
                variant="text"
                onClick={() => {
                  setStep('koalm');
                  setOtp('');
                  setError('');
                  setMessage('');
                }}
                disabled={loading}
              >
                Back
              </Button>
            </form>
          )}
          </Paper>
        </Container>
      </Box>
      <MemberPortalFooter />
    </Box>
  );
};

export default Login;

